// FindTenantArticle.tsx
import { Col, Row } from "react-bootstrap";
import MaterialIcon from "../../material-icon";
import { colorPalette } from "../../../utils/theme";
import useIsMobile from "../../../hooks/useIsMobile";
import { ArticleImage, ArticleTitle, ArticleSubtitle, SharingContainer, ArticleDescription, Headline, ThreeDots, ArticleText, FilterContainer, AuthorName, SubHeadline, ArticleImageContainer, BulletPointItem, BulletPointList } from "../article.styles";
import PropertyManagementImage from "../../../assets/images/articles/property-management-large.webp";
import PropertyManagementMobileImage from "../../../assets/images/articles/property-management.webp";
import Filter from "../../filter/filter";
import { useCallback } from "react";
import { useTranslation } from 'react-i18next';

interface FindTenantArticleProps {
    onClickShare: () => void;
}

const FindTenantArticle: React.FC<FindTenantArticleProps> = ({ onClickShare }) => {
    const isMobile = useIsMobile();
    const { t } = useTranslation();

    const renderHeaderContent = useCallback(() => {
        return (
            <ArticleImageContainer>
                <ArticleImage
                    src={isMobile ? PropertyManagementMobileImage : PropertyManagementImage}
                    alt="Article Thumbnail"
                    showBorderRadius={!isMobile}
                />
            </ArticleImageContainer>
        );
    }, []);

    return (
        <>
            {isMobile && (
                renderHeaderContent()
            )}

            <Row className="justify-content-center flex-grow-1" style={{ paddingLeft: 16, paddingRight: 16 }}>
                <Col xs={12} lg={8} xl={6}>
                    <ArticleTitle>{t("articles.find_tenant.title")}</ArticleTitle>
                    <ArticleSubtitle>{t("articles.find_tenant.subtitle")}</ArticleSubtitle>

                    <SharingContainer>
                        <AuthorName>Managd Knowledge Hub</AuthorName>
                        <MaterialIcon icon="share" size={24} color={colorPalette.textDark} onClick={onClickShare} />
                    </SharingContainer>

                    {!isMobile && (
                        renderHeaderContent()
                    )}

                    <ArticleDescription>{t("articles.find_tenant.intro")}</ArticleDescription>

                    <ThreeDots />

                    <Headline>{t("articles.find_tenant.section_title")}</Headline>
                    <ArticleText>{t("articles.find_tenant.section_text")}</ArticleText>

                    <SubHeadline>{t("articles.find_tenant.section1_title")}</SubHeadline>
                    <ArticleText>{t("articles.find_tenant.section1_text")}</ArticleText>

                    <SubHeadline>{t("articles.find_tenant.section2_title")}</SubHeadline>
                    <ArticleText>{t("articles.find_tenant.section2_text")}</ArticleText>

                    <SubHeadline>{t("articles.find_tenant.section3_title")}</SubHeadline>
                    <ArticleText>{t("articles.find_tenant.section3_text")}</ArticleText>


                    <SubHeadline>{t("articles.find_tenant.section4_title")}</SubHeadline>
                    <ArticleText>{t("articles.find_tenant.section4_text")}</ArticleText>

                    <ThreeDots />

                    <Headline>{t("articles.find_tenant.why_managd_title")}</Headline>
                    <ArticleText>{t("articles.find_tenant.why_managd_text")}</ArticleText>

                    <BulletPointList>
                        <BulletPointItem>{t("articles.find_tenant.benefit1")}</BulletPointItem>
                        <BulletPointItem>{t("articles.find_tenant.benefit2")}</BulletPointItem>
                        <BulletPointItem>{t("articles.find_tenant.benefit3")}</BulletPointItem>
                    </BulletPointList>

                    <ThreeDots />

                    <Headline>{t("articles.find_tenant.conclusion_title")}</Headline>
                    <ArticleText>{t("articles.find_tenant.conclusion_text")}</ArticleText>

                    {/*<FilterContainer>
                        <Filter label="Handover" disabled />
                        <Filter label="Mietverwaltung" disabled />
                        <Filter label="Services" disabled />
                    </FilterContainer>*/}
                </Col>
            </Row>
        </>
    );
};

export default FindTenantArticle;
